import React from "react";
import Container from "react-bootstrap/Container";
import { Heading,T  } from "../components/helpful";
import Post from "../components/layouts/post";


export default class Blog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageTitle: <T value={"Blog"}/>,
      hotelImg: 0,
      desc: <T value={"Last blog informations"}/> ,
    };

  }

  subHeading = () => {
    return <>{this.state.desc}</>;
  };

  render() {
    return (
      <div >
        <div className="">
          <div>
            <Heading heading={this.state.pageTitle} Desc={this.subHeading} />
          </div>

          <div className="main-content">
            <Post/>
          </div>
        </div>
      </div>
    );
  }
}
